/**
 * The title's intro (decision 77): its loops, on the UI's runner, until the player's first gesture. Seconds; colours as
 * hex.
 */
export const INTRO_TUNING = {
  /** LIFE: the full meter rests, drains a slot at a time, rests empty, then refills, its slots popping. */
  life: { fullSeconds: 1.1, drainEverySeconds: 0.7, drainSeconds: 0.35, emptySeconds: 0.45, refillPopSeconds: 0.35 },
  /**
   * MULTI: the ×2 falls onto the coin's corner and pops, rests, goes into the coin as the bonus's payout's do (onto its
   * centre, growing, then swelling out), the coin swells and shows ×2 under its name for a while, which fades before the
   * next.
   */
  multi: { fallSeconds: 0.45, landPopSeconds: 0.18, restSeconds: 0.45, mergeMoveSeconds: 0.22, mergePopSeconds: 0.28, swellSeconds: 0.3, showSeconds: 1.3, fadeSeconds: 0.3, gapSeconds: 0.5 },
  /** GROW: its ROYAL plaque glints this often. */
  grow: { glintEverySeconds: 2.2 },
  /** The pots' glow: each pot's colour, pulsing between the alphas over a beat, each a third of a beat after the last. */
  glow: { periodSeconds: 2.4, alpha: [0.3, 0.7], tint: { life: 0x46ff70, multi: 0xff5a3a, grow: 0x4aa0ff } },
  /** The embers rising over the background: how many, how fast (design units a second), how long each lives, how big. */
  embers: { count: 26, speed: [50, 130], lifeSeconds: [2.5, 5.5], size: [14, 34], tint: 0xffa23a },
} as const;
